
const eCircleProgressBar = {
    props: {
        currentStep:{
            type: Number,
            default: 1,
        },
        allSteps:{
            type: Object,
            default(){
                return []
            },
        },
        icn:""
    },
    template:`
    <div class="e-circle-progress-bar" :class="completedClass">

        <div class="e-circle-progress-bar__svgs">
            <svg class="e-circle-progress-bar__svgs__bg" viewbox="0 0 100 100">
                <circle class="e-circle-progress-bar__circle-bg" r="117" cx="121" cy="121"></circle>
            </svg>
            <svg class="e-circle-progress-bar__svgs__blue" viewbox="0 0 100 100">
                <circle class="e-circle-progress-bar__circle-blue" r="117" cx="121" cy="121" :stroke-dasharray="max" :stroke-dashoffset="activeBlueValue">
                </circle>
            </svg>
            <svg class="e-circle-progress-bar__svgs__red" viewbox="0 0 100 100">
                <circle class="e-circle-progress-bar__circle-red" r="117" cx="121" cy="121" :stroke-dasharray="max" :stroke-dashoffset="activeRedValue">
                </circle>
            </svg>
        </div>

        <div class="e-circle-progress-bar__txt">
            <div class="e-circle-progress-bar__num"><div class="e-circle-progress-bar__num__txt">{{currentStep}}</div></div>
            <div class="e-circle-progress-bar__icn"><img v-if="icn!==''" :src="icn" alt=""></div>
            <div class="e-circle-progress-bar__lbl">{{currentStepLbl}}</div>
        </div>

    </div>`,
    data() {
        return {
            min: 0,
            max: 736,
            activeBlueValue: 0,
            activeRedValue: 0,
            progress:0
        }
    },
    mounted(){
        this.calcProgress(0)
        
    },
    methods:{
        calcVal(perc){
            return this.max  - (perc * this.max) / 100
        },
        setValue(perc){     
            var blueVal = Math.min(perc, 50)
            var redVal = Math.max((perc) - 50, 0)  

            this.activeBlueValue = this.calcVal(blueVal)   
            this.activeRedValue = this.calcVal(redVal)   
        },
        calcProgress(cstep){
            const perc = ((cstep / this.allSteps.length)  * 100).toFixed(0);;
            this.progress = perc

            this.setValue(perc)
        }
    },
    computed:{
        isCompleted(){
            return this.progress >= 100
        },
        completedClass(){
            return this.isCompleted ? "completed" : ""
        },
        currentStepLbl(){
            let lbl = ""
            if(this.allSteps.length && this.allSteps[this.currentStep-1])
                lbl = this.allSteps[this.currentStep-1].lbl

            return lbl
        }
    },
    watch:{
        currentStep:{
            handler(newval, oldval){
                this.$nextTick(()=>{
                    this.calcProgress(newval)
                })
            },
            immediate: true
        }
    }
}